{
  "familyId": "SPR-ACCENT",
  "questions": [
    {
      "id": "SPR-ACCENT-001",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "multiple_choice",
      "question": "Welk woord heeft een accent nodig om de juiste betekenis te krijgen?",
      "context": "Ik drink graag een kopje thee in het ...",
      "options": ["café", "cafe", "cafë", "kafé"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Accenten in het Nederlands", "content": "Een accent aigu (é) geeft aan dat de klinker lang en beklemtoond is. Zonder accent zou 'cafe' rijmen op 'safe'. Met accent wordt het 'café' (klemtoon op de laatste lettergreep). Regel: leenwoorden uit het Frans behouden vaak hun accent.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "accent_aigu_loanwords",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: leenwoorden uit het Frans behouden hun accent. Stap 1: 'café' komt uit het Frans. Stap 2: Het accent aigu (é) geeft de klemtoon aan op de laatste lettergreep. Stap 3: Zonder accent verandert de uitspraak: 'cafe' zou rijmen op 'safe'. Dus: café (met accent aigu).",
        "distractorExplanations": {
          "0": "Correct! 'Café' heeft een accent aigu (é) op de laatste lettergreep. Dit is een Frans leenwoord dat zijn accent behoudt.",
          "1": "Veelgemaakte fout: het accent weglaten. Zonder accent verandert de uitspraak: 'cafe' rijmt op 'safe'. Het accent aigu (é) is nodig om de juiste klemtoon aan te geven: café.",
          "2": "Veelgemaakte fout: het verkeerde accent gebruiken. Een trema (ë) gebruik je om aan te geven dat twee klinkers apart worden uitgesproken (zoals in 'geëist'). Hier heb je een accent aigu (é) nodig: café.",
          "3": "Veelgemaakte fout: de 'c' vervangen door 'k'. In het Nederlands schrijven we dit Franse leenwoord met een 'c': café (niet kafé)."
        }
      }
    },
    {
      "id": "SPR-ACCENT-002",
      "familyId": "SPR-ACCENT",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leestekens",
      "subSkill": "accent_klemtoon",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist? 'De ... hond blafte hard.'",
      "context": null,
      "options": ["blaffende", "blaffnde", "geblaffde", "blaffde"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Tegenwoordig deelwoord", "content": "Regel: een werkwoord als bijvoeglijk naamwoord krijgt de uitgang -ende: blaffen → blaffende (hond). Dit is het tegenwoordig deelwoord. Stap 1: neem het hele werkwoord (blaffen). Stap 2: voeg -de toe: blaffende.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "verb_as_adjective",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: tegenwoordig deelwoord. Stap 1: Neem het hele werkwoord: blaffen. Stap 2: Voeg -de toe: blaffen + de = blaffende. Het tegenwoordig deelwoord beschrijft een actie die nu plaatsvindt: de blaffende hond = de hond die nu blaft.",
        "distractorExplanations": {
          "0": "Correct! Tegenwoordig deelwoord: blaffen + de = blaffende.",
          "1": "Veelgemaakte fout: een letter weglaten. Je vergeet de 'e' in -ende. De regel is: heel werkwoord + de = blaffende (niet blaffnde).",
          "2": "Veelgemaakte fout: voltooid deelwoord gebruiken in plaats van tegenwoordig deelwoord. 'Geblaffde' lijkt op het voltooid deelwoord (ge- + stam + d), maar hier heb je het tegenwoordig deelwoord nodig: blaffende (werkwoord + de).",
          "3": "Veelgemaakte fout: verleden tijd verwarren met tegenwoordig deelwoord. 'Blaffde' lijkt op de verleden tijd (stam + de). Het tegenwoordig deelwoord is: heel werkwoord + de = blaffende."
        }
      }
    }
  ]
}